<div class="content__container">
  <div class="goback__wrapper" *ngIf="vinoSelezionato && !stepVino">
    <div class="goback__item" (click)="tornaIndietro()">
      <span class="material-symbols-outlined"> chevron_left </span>
      {{ "base.altri_vini" | translate }}
    </div>
  </div>
  <h2 class="d-flex align-items-baseline flex-header tipovisita__title">
    <b>
      {{ vino.nome }}
      <small *ngIf="!vino.disponibile">({{ "base.nodisp" | translate }})</small>
    </b>
  </h2>
  <div class="tags" *ngIf="vino.tags && vino.tags.length > 0">
    <app-tags-vino [tags]="vino.tags"></app-tags-vino>
  </div>
  <div class="price__container">
    <div class="prezzo-box" *ngIf="vino.disponibile">
      <div class="prezzo scontato" *ngIf="vino.hasSconto(vino) && vino.prezzo">
        € {{ vino.choosePrezzoScontato(vino) | number : "1.2-2" }}
      </div>
      <div
        class="prezzo"
        [ngClass]="vino.hasSconto(vino) ? 'inSconto' : 'not-inSconto'"
      >
        € {{ vino.prezzo | number : "1.2-2" }}
      </div>
    </div>
  </div>
  <div class="associata" *ngIf="vino.associate && vino.associate_sconto != 0">
    <span *ngIf="vino.associate_sconto == 100">
      {{ "base.visita_inclusa_tot" | translate }}
    </span>
    <span *ngIf="vino.associate_sconto != 100 && vino.associate_sconto != 0">
      {{
        "base.visita_inclusa_parziale"
          | translate : { value: vino.associate_sconto }
      }}
    </span>
    <span *ngIf="!vino.associate"> &nbsp; </span>
  </div>
  <hr class="divisore" />

  <div class="mb-descrizione">
    <div class="mb-2 mt-1" *ngIf="specificheDef.length > 0">
      <app-specifiche-vino
        [specifiche]="vino.specificheList"
        [vino]="vino"
      ></app-specifiche-vino>
    </div>
    <a
      class="link"
      href="{{ vino.pdfVino }}"
      target="_blank"
      *ngIf="vino.pdfVino && vino.pdfVino !== ''"
    >
      {{ "base.scarica_pdf_vino" | translate }}
      <span class="material-symbols-outlined icon"> download </span>
    </a>
    <app-testo-espandibile [text]="vino.descrizione"></app-testo-espandibile>
  </div>

  <div class="d-flex justify-content-start" *ngIf="!vinoSelezionato">
    <div class="button__container">
      <button class="button__booking" (click)="emitSelezionaVino(vino)">
        {{ "base.scegli_qta" | translate }}
        <span class="material-symbols-outlined"> shopping_cart </span>
      </button>
    </div>
  </div>
</div>
